import React from 'react';

import SectionText from '../../presentational/SectionText';
import DotPoints from '../../presentational/DotPoints';
import data from '../../../core/data';
import Image from '../../presentational/Image';

import freshSkinLogo from '../../../images/phyto/1day.png';
import newSkinLogo from '../../../images/phyto/5days.png';
import bpeelLogo from '../../../images/phyto/bpeel-b-logo.png';
import cpeelLogo from '../../../images/phyto/cpeel-c-logo.png';
import leafIcon from '../../../images/leaf-icon.png';

const array = data.phyto.comparison.treatmentGoals;

function HAPComparisonContainer(props) {
  return (
    <section id="phyto">
      <div className="container">
        <h1 className="header">BPeel <img className="leaf-icon" src={ leafIcon } /> CPeel Comparison</h1>
        <div className="row">
          <div>
            <div className="header">
              <p><b>Treatment Goals</b></p>
            </div>
            <div className="col-xs-12 bordered">
              <DotPoints array={ array } />
            </div>
          </div>
          <div className="col-xs-6">
            <SectionText heading="">
              <img className="small-logo" src={ bpeelLogo } />
              <DotPoints array={ data.phyto.comparison.phytoPoints } />
            </SectionText>
          </div>
          <div className="col-xs-6">
            <SectionText heading="">
              <img className="small-logo" src={ cpeelLogo } />
              <DotPoints array={ data.phyto.comparison.HAPPoints } />
            </SectionText>
          </div>
        </div>
        <div className="col-xs-6 logo">
          <img src={ freshSkinLogo } alt="Fresh skin in 1 day logo" />
        </div>
        <div className="col-xs-6 logo">
          <img src={ newSkinLogo } alt="New skin in 5 days logo" />
        </div>
      </div>
    </section>
  )
}

export default HAPComparisonContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/HAPComparisonContainer.jsx
 **/